import { render, staticRenderFns } from "./error_screen.vue?vue&type=template&id=347bfd7e&"
import script from "./error_screen.vue?vue&type=script&lang=js&"
export * from "./error_screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347bfd7e')) {
      api.createRecord('347bfd7e', component.options)
    } else {
      api.reload('347bfd7e', component.options)
    }
    module.hot.accept("./error_screen.vue?vue&type=template&id=347bfd7e&", function () {
      api.rerender('347bfd7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/errors/error_screen.vue"
export default component.exports